<template>
  <div class="mpim">
    <link-model to="https://morse.lhcyh.site">摩斯输入法下载</link-model>
    <version-manage 
      deleteVersionApi="/resources/deleteResourcesById"
      getMaxVersionApi="/mpimResources/getMaxVersion"
      setLastVersionApi="/resources/updateResources"
      getVersionListApi="/mpimResources/getVersionList"
      addNotForceVersionApi="/mpimResources/addFileVersion">
    </version-manage>
  </div>
</template>

<script>
import LinkModel from '../../components/LinkModel.vue'
import VersionManage from '../../components/VersionManage.vue'
export default {
  name:"Mpim",
  components: { LinkModel,VersionManage },
  data:function(){
    return {
      
    }
  }
}
</script>

<style lang="less" scoped>
.mpim{
  width:100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>